import { render, staticRenderFns } from "./BookHistory.vue?vue&type=template&id=157b6088"
import script from "./BookHistory.vue?vue&type=script&lang=js"
export * from "./BookHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports